import axios from './axios_utils'

if (Athena === undefined) {
  var Athena = {}
}

Athena.routes = {}
Athena.routes.product_specifications_api = function (product_id) {
  return '/admin/products/' + product_id + '/product_specifications/'
}
Athena.routes.categories_api = function (taxonomy_id) {
  return '/admin/taxonomies/' + taxonomy_id + '/categories/'
}
Athena.routes.category_move_up_api = function () {
  return "/admin/categories/move_up/";
}

Athena.routes.category_move_down_api = function () {
  return "/admin/categories/move_down/";
}
Athena.ajax = function (url, options) {
  if (typeof url === "object") {
    options = url;
    url = undefined;
  }
  options = options || {};
  options = $.extend(options, {
    headers: {
      'Authorization': 'Bearer ' + Athena.api_key
    }
  });

  return axios(options);
};

window.Athena = Athena;
